import React from "react";
import { BrandLockup } from "./LogoMark";
import { Instagram, Facebook, Music2 } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#F8F9FA] border-t border-slate-200/70 py-12">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col items-center gap-8">
      <BrandLockup testid="footer-logo-link" />
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-500">
        <a href="#richiesta" className="hover:text-[#0A192F] transition-colors">Richiedi casa</a>
        <a href="/richieste" className="hover:text-[#0A192F] transition-colors">Richieste attive</a>
        <a href="#come-funziona" className="hover:text-[#0A192F] transition-colors">Come funziona</a>
        <a href="#agenzie" className="hover:text-[#0A192F] transition-colors">Agenzie</a>
        <a href="/privacy-policy" className="hover:text-[#0A192F] transition-colors">Privacy</a>
        <a href="/cookie-policy" className="hover:text-[#0A192F] transition-colors">Cookie</a>
        <a href="/admin" data-testid="footer-admin-link" className="hover:text-[#0A192F] transition-colors">Area riservata</a>
      </div>
      <div className="flex items-center gap-4">
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Seguici su</p>
        <a
          href="https://instagram.com/casamatch.casacercate"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-instagram"
          aria-label="Instagram"
          className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-gradient-to-tr hover:from-purple-500 hover:via-pink-500 hover:to-orange-400 hover:text-white hover:border-transparent transition-all"
        >
          <Instagram className="w-4.5 h-4.5" />
        </a>
        <a
          href="https://facebook.com/casamatch.casacercate"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-facebook"
          aria-label="Facebook"
          className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-[#1877F2] hover:text-white hover:border-transparent transition-all"
        >
          <Facebook className="w-4.5 h-4.5" />
        </a>
        <a
          href="https://tiktok.com/@casamatch.casacercate"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-tiktok"
          aria-label="TikTok"
          className="w-10 h-10 rounded-full bg-white border border-slate-200 flex items-center justify-center text-slate-500 hover:bg-black hover:text-white hover:border-transparent transition-all"
        >
          <Music2 className="w-4.5 h-4.5" />
        </a>
      </div>
      <p className="text-xs text-slate-400 text-center">© {new Date().getFullYear()} Casamatch.org — La casa cerca te!</p>
    </div>
  </footer>
);
